/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_ClassifyingInputs */

const en_upload_classifying = /** @type {(inputs: Upload_ClassifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classifying…`)
};

const pt_br2_upload_classifying = /** @type {(inputs: Upload_ClassifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificando…`)
};

/**
* | output |
* | --- |
* | "Classifying…" |
*
* @param {Upload_ClassifyingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_classifying = /** @type {((inputs?: Upload_ClassifyingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_ClassifyingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_classifying(inputs)
	return pt_br2_upload_classifying(inputs)
});